import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as config from '../backend.config';
import { PageClass } from '../../filters/filters';

// ----------------------------------------------
// Service for Publisher / Payments
// Component:
// ----------------------------------------------

const ADDRS_API = config.API;

// API description for all commnication with BACK-END for accounts management
// ----------------------------------------------
// BACK-END API
// ----------------------------------------------



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})

export class PaymentsService {
  constructor(private http: HttpClient) { }

  getPaymentsDetails(): Observable<any> {
    return this.http.get(ADDRS_API + `/publishers/payments/details`);
  }

  updateMethod( data: any): Observable<any> {
    return this.http.put(ADDRS_API + `/publishers/payments/method`, data);
  }

  updatePreffered( data: any): Observable<any> {
    return this.http.put(ADDRS_API + `/publishers/payments/preferred-payout-method`, data);
  }

  getPayments(page: PageClass): Observable<any> {
    return this.http.post(ADDRS_API + `/publishers/payments/data`, page);
  }

  getBalance(): Observable<any> {
    return this.http.get(ADDRS_API + `/publishers/payments/balance`);
  }
}
